module.exports = __webpack_public_path__ + "img/borderRing2White.f80e2a81.svg";